import * as tslib_1 from "tslib";
import { m } from '../hyperscript';
/*export function wrap<L extends {}, T extends Component<{}>>(
    layout: Component<Partial<L>>,
    options: Partial<L> = {}
): (component: T) => T {*/
export function wrap(layout, options) {
    return function (component) {
        var Layout = layout;
        var Component = component;
        var comp = function (_a) {
            var children = _a.children, attrs = tslib_1.__rest(_a, ["children"]);
            return (m(Layout, tslib_1.__assign({}, attrs, options),
                m(Component, tslib_1.__assign({}, attrs), children)));
        };
        return comp;
    };
}
